import React from 'react';
import { observer } from 'mobx-react';
import { AvGroup, AvInput, AvForm } from 'availity-mobx-reactstrap-validation';
import { Label } from 'reactstrap';

import ErrorDisplay from 'js/components/common/ErrorDisplay';
import Button from 'js/components/common/Button';
import SubmitRow from 'js/components/core/Modal/SubmitRow';
import Icon from './Icon';
import Title from './Title';
import Container from './Container';
import Message from './Message';

export default observer(({ state }) => (
  <Container>
    <AvForm onValidSubmit={state.verifyBankAccount}>
      <Icon name="university" />
      <Title>Verify microdeposits</Title>

      <Message>
        <div>We have issued one or two microtransactions (less than $1 each) on your account.</div>
        <div>Once you see them, come back here and verify your account by entering the values below.</div>
      </Message>

      <AvGroup>
        <Label for="first">Deposit 1</Label>
        <AvInput type="text" name="first" id="first" required />
      </AvGroup>

      <AvGroup>
        <Label for="second">Deposit 2</Label>
        <AvInput type="text" name="second" id="second" required />
      </AvGroup>

      <ErrorDisplay>{state.verifyError}</ErrorDisplay>

      <SubmitRow>
        <Button isLoading={state.isVerifying} autoFocus type="submit">
          Save
        </Button>
      </SubmitRow>
    </AvForm>
  </Container>
));
